<!--
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-08-10 10:36:12
 * @LastEditTime: 2020-09-11 10:26:58
 * @Description: 公司页面
-->
<template>
  <div class="container">
    <div class="handle-wrapper">
      <Input
        v-model="searchText"
        search
        placeholder="搜索公司..."
        @on-change="searchSacCompany"
        style="width: 250px; margin-right: auto"
      >
        <Button
          slot="append"
          icon="ios-search"
          @click="searchSacCompany"
        ></Button>
      </Input>
      <span>共{{ totalRows }}条</span>
      <Page
        :total="totalRows"
        :page-size="15"
        @on-change="loadSacCompany"
        show-total
        simple
        style="margin-right: 24px"
      />
      <Button type="primary" @click="$refs.AddCompanyDrawer.openDrawer()"
        >新增公司</Button
      >
    </div>
    <div class="table-wrapper" ref="tableWrapper">
      <Table
        :loading="tableLoading"
        :columns="columns"
        :data="tableData"
        :height="tableHeight"
      />
    </div>
    <AddCompanyDrawer ref="AddCompanyDrawer" />
  </div>
</template>

<script>
import AddCompanyDrawer from "./AddCompanyDrawer";
import { mapState, mapActions } from "vuex";
import _ from "lodash";

export default {
  name: "Company",
  components: { AddCompanyDrawer },
  props: {},
  data() {
    return {
      page: 0,
      tableHeight: 300,

      searchText: "",
      tableLoading: false,
      columns: [
        {
          title: "名字",
          key: "name",
          render: (h, params) => {
            return h("div", [
              h(
                "h4",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  style: {
                    color: "#42b983",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$refs.AddCompanyDrawer.openDrawer(params.row);
                    },
                  },
                },
                params.row.name
              ),
            ]);
          },
        },
        {
          title: "简称",
          key: "abbr",
          render: (h, params) => {
            return h("div", [h("span", params.row.abbr)]);
          },
        },
      ],
    };
  },
  computed: {
    ...mapState({
      tableData: (state) => state.company.companyList,
      totalRows: (state) => state.company.totalCounts,
    }),
  },
  methods: {
    ...mapActions({
      getCompanyList: "company/getCompanyListAction",
    }),
    async loadSacCompany(page) {
      if (page) this.page = page - 1;
      let api = { skip: this.page * 15, limit: 15 };
      if (this.searchText) api.searchText = this.searchText;

      try {
        this.tableLoading = true;
        await this.getCompanyList(api);
        this.tableLoading = false;
      } catch (error) {
        this.$Message.error(`加载失败: ${error}`);
        this.tableLoading = false;
      }
    },
    searchSacCompany: _.debounce(function () {
      this.page = 0;
      this.loadSacCompany();
    }, 1000),
  },
  created() {
    this.loadSacCompany();
  },
  mounted() {
    this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    window.onresize = () => {
      this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    };
  },
  destroyed() {
    window.onresize = null;
  },
};
</script>

<style scoped lang="stylus">
.handle-wrapper
  width 100%
  height 48px
  display flex
  align-items center
  justify-content flex-end

.table-wrapper
  width 100%
  height calc(100% - 48px)
</style>
